import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="w-full border-y-4 border-gold bg-plum" data-id="element-50" data-mp="1zyh2w7skw2x2">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-51" data-mp="1uy2xkxid372q">
        <h2 className="font-display font-bold text-white text-3xl sm:text-5xl" data-id="element-52" data-mp="1v05w65xky8j2">
          Keep your evenings.{' '}
          <span className="text-gold" data-id="element-53" data-mp="1l059ca0i5aa4">Open the week and teach.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/75" data-id="element-54" data-mp="1l29jh9ozv5iu">
          Start strong, find the groove, travel, create, build the showcase and
          take a bow. Forty weeks — counted, leveled and ready.
        </p>

        <div className="mt-7" data-id="element-55" data-mp="1790hhu3dlmac">
          <Countdown size="sm" tone="dark" data-id="element-56" data-mp="17a1sxzob0asl" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-3xl border border-gold bg-gold/10 px-5 py-4 text-left" data-id="element-57" data-mp="129e3vjjmy410">
          <div data-id="element-58" data-mp="xbcksym7m4pj">
            <span className="block text-[10px] font-semibold uppercase tracking-widest text-gold" data-id="element-59" data-mp="xcx41s32q183">
              Complete package
            </span>
            <span className="text-[15px] font-semibold text-white" data-id="element-60" data-mp="41sr4nxpdj4d">
              Dance Class Ready — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-61" data-mp="3lfeerjnlqvxq">
            <span className="text-[15px] text-white/60 line-through" data-id="element-62" data-mp="3qh3ql1infdmv">$90</span>
            <span className="font-display text-4xl font-bold leading-none text-white" data-id="element-63" data-mp="i08x2cnqr5lg">
              $27
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-64" data-mp="mx93iooi6ad3">
          <CtaButton data-id="element-65" data-mp="81azkk8c81qb">Yes, I want the full season — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-66" data-mp="d0wa7rwvdyiv">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-67" data-mp="2xs67iw6m5ct2">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-68" data-mp="2xpa976qusm43" />
                {item}
              </li>)}
        </ul>
      </div>
    </section>;
}